.faq-page {
  padding-bottom: 4rem;
}

.faq-header {
  background: var(--surface-color);
  padding: 4rem 0 2rem;
  text-align: center;
  border-bottom: 1px solid var(--border-color);
}

.faq-header h1 {
  font-family: 'Outfit', sans-serif;
  color: var(--text-primary);
  margin-bottom: 1rem;
  font-size: 3rem;
}

.faq-header p {
  color: var(--text-secondary);
  max-width: 600px;
  margin: 0 auto;
}

.faq-content {
  padding: 3rem 0;
}

.faq-wrapper {
  max-width: 800px;
  margin: 0 auto;
}

.category-title {
  font-family: 'Outfit', sans-serif;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  font-size: 1.5rem;
}

.accordion {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.accordion-item {
  background: var(--glass-bg);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.accordion-item:hover {
  border-color: rgba(240, 180, 41, 0.25);
}

.accordion-item.open {
  border-color: var(--secondary-gold);
}

.accordion-header {
  width: 100%;
  padding: 1.15rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  border: none;
  color: var(--text-primary);
  font-weight: 600;
  font-size: 1.05rem;
  cursor: pointer;
  text-align: left;
  transition: color 0.3s ease;
}

.accordion-header:hover {
  color: var(--secondary-gold);
}

.accordion-icon {
  color: var(--secondary-gold);
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.accordion-item.open .accordion-icon {
  transform: rotate(180deg);
}

.accordion-body {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
}

.accordion-item.open .accordion-body {
  max-height: 500px;
}

.accordion-content {
  padding: 0 1.5rem 1.25rem;
  color: var(--text-secondary);
  line-height: 1.7;
}
